import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { COLORS } from '../constants';

const Footer = ({ setActiveSection, onTrackOrder }) => {
  const { t } = useLanguage();

  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="footer-inner">
        <div>
          <img src="/images/beautykit-logo.png" alt="BeautyKit" className="footer-logo" data-testid="footer-logo" />
          <div className="footer-dots">
            {Object.values(COLORS).map((c) => <i key={c} style={{ background: c, color: c }} />)}
          </div>
          <p className="footer-meta">
            {t('footer.company')} · <a href="mailto:lamonilab@gmail.com">{t('footer.email')}</a>
          </p>
        </div>

        <div>
          <div className="footer-links">
            <button onClick={() => setActiveSection('privacy')} data-testid="footer-privacy">{t('footer.privacy')}</button>
            <button onClick={() => setActiveSection('terms')} data-testid="footer-terms">{t('footer.terms')}</button>
            <button onClick={() => setActiveSection('cookies')} data-testid="footer-cookies">{t('footer.cookies')}</button>
            <button onClick={onTrackOrder} className="footer-track" data-testid="footer-track-order">{t('footer.track')}</button>
          </div>
          <p className="footer-copy">{t('footer.rights')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
